










































































































































































































































































import { Vue, Component, Prop } from 'vue-property-decorator';
import omegaup_Markdown from '../Markdown.vue';
import T from '../../lang';
import * as ui from '../../ui';
import 'intro.js/introjs.css';
import introJs from 'intro.js';
import VueCookies from 'vue-cookies';
import { getBlogUrl } from '../../urlHelper';
Vue.use(VueCookies, { expire: -1 });

@Component({
  components: {
    'omegaup-markdown': omegaup_Markdown,
  },
})
export default class Signup extends Vue {
  @Prop() validateRecaptcha!: boolean;
  @Prop() hasVisitedSection!: boolean;
  @Prop({ default: false }) useSignupFormWithBirthDate!: boolean;

  T = T;
  ui = ui;
  username: string = '';
  email: string = '';
  dateOfBirth: string = '';
  parentEmail: string = '';
  password: string = '';
  passwordConfirmation: string = '';
  recaptchaResponse: string = '';
  isUnder13: boolean = true;
  over13Checked: boolean = false;
  termsAndPolicies: boolean = false;

  mounted() {
    const title = T.signUpFormInteractiveGuideTitle;

    if (!this.hasVisitedSection) {
      introJs()
        .setOptions({
          nextLabel: T.interactiveGuideNextButton,
          prevLabel: T.interactiveGuidePreviousButton,
          doneLabel: T.interactiveGuideDoneButton,
          steps: [
            {
              title,
              intro: T.signUpFormInteractiveGuideWelcome,
            },
            {
              element: document.querySelector('.introjs-username') as Element,
              title,
              intro: T.signUpFormInteractiveGuideUsername,
            },
            {
              element: document.querySelector('.introjs-email') as Element,
              title,
              intro: T.signUpFormInteractiveGuideEmail,
            },
            {
              element: document.querySelector('.introjs-password') as Element,
              title,
              intro: T.signUpFormInteractiveGuidePassword,
            },
            {
              element: document.querySelector(
                '.introjs-confirmpassword',
              ) as Element,
              title,
              intro: T.signUpFormInteractiveGuideConfirmPassword,
            },
            {
              element: document.querySelector(
                '.introjs-terms-and-conditions',
              ) as Element,
              title,
              intro: T.signUpFormInteractiveGuideTermsAndConditions,
            },
            {
              element: document.querySelector('.introjs-register') as Element,
              title,
              intro: T.signUpFormInteractiveGuideRegister,
            },
          ],
        })
        .start();
      this.$cookies.set('has-visited-signup', true, -1);
    }
  }

  verify(response: string): void {
    this.recaptchaResponse = response;
  }

  expired(): void {
    this.recaptchaResponse = '';
  }

  // ADD Computed property to format the markdown string
  get formattedAcceptPolicyMarkdown(): string {
    const policyUrl = getBlogUrl('PrivacyPolicyURL');
    const conductUrl = getBlogUrl('CodeofConductPolicyURL');

    // Use ui.formatString to inject the fetched URLs into the translation string
    const formattedstring = ui.formatString(T.acceptPrivacyPolicy, {
      PrivacyPolicyURL: policyUrl,
      CodeofConductPolicyURL: conductUrl,
    });

    return formattedstring;
  }

  get maxDateForTimepicker() {
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = (currentDate.getMonth() + 1)
      .toString()
      .padStart(2, '0');
    const currentDay = currentDate.getDate().toString().padStart(2, '0');

    return this.over13Checked
      ? `${currentYear - 13}-${currentMonth}-${currentDay}`
      : `${currentYear}-${currentMonth}-${currentDay}`;
  }

  get minDateForTimepicker() {
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = (currentDate.getMonth() + 1)
      .toString()
      .padStart(2, '0');
    const dayFollowingTheCurrent = (currentDate.getDate() + 1)
      .toString()
      .padStart(2, '0');

    return this.over13Checked
      ? '1900-01-01'
      : `${currentYear - 13}-${currentMonth}-${dayFollowingTheCurrent}`;
  }

  updateDateRestriction() {
    if (this.over13Checked) {
      this.isUnder13 = false;
      return;
    }
    this.isUnder13 = true;
  }
}
